export const siteSettings = {
  name: "Stock Option Exchange",
  link: "https://stockoptionexchange.live",
  email: "support@stockoptionexchange.live",
  appLink: "https://app.stockoptionexchange.live",
};
